<template>
  <li class="mutation">
    <div class="d-flex mutation align-items-center py-2">
      <span class="icon-wrapper ske ske-photo" :class="reason">
        <svg v-if="reason === 'SOLD_TO_CUSTOMER'" width="18" height="18" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"></path>
        </svg>
        <svg v-else-if="reason === 'ADDED_STOCK'" width="18" height="18" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l2-2a1 1 0 00-1.414-1.414L11 7.586V3a1 1 0 10-2 0v4.586l-.293-.293z"></path><path d="M3 5a2 2 0 012-2h1a1 1 0 010 2H5v7h2l1 2h4l1-2h2V5h-1a1 1 0 110-2h1a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5z"></path>
        </svg>
        <svg v-else-if="reason === 'MODIFIED_IN_BACKOFFICE'" width="18" height="18" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M2 5a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm14 1a1 1 0 11-2 0 1 1 0 012 0zM2 13a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2v-2zm14 1a1 1 0 11-2 0 1 1 0 012 0z" clip-rule="evenodd"></path>
        </svg>
        <svg v-else-if="reason === 'RETURNED_ORDER'" width="18" height="18" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clip-rule="evenodd"></path>
        </svg>
      </span>
      <span class="ml-2 content d-flex flex-column">
        <span>
          <span class="ske">
            <span v-html="content" class="text"></span>
          </span>
        </span>
        <span class="stock-info">
          <span class="ske">
            Stock: {{ previousStock }} -> {{ newStock }}
          </span>
          <span v-if="user" class="ske ml-2">
            <span>{{ user.name }}({{ user.email }})</span>
          </span>
        </span>
      </span>
      <span class="date">
        <span v-if="orderNumber" class="ske">
          Order number: {{ orderNumber }}
        </span>
        <span class="ml-2 ske">
          {{ formattedDate }}
        </span>
      </span>
    </div>
  </li>
</template>

<script>

import { format } from 'date-fns'

export default {
  props: {
    sku: String,
    reason: String,
    newStock: Number,
    previousStock: Number,
    orderNumber: Number,
    diff: Number,
    createdAt: String,
    user: Object,
  },
  computed: {
    content() {
      const negative = this.diff < 0
      const diff = Math.abs(this.diff)

      const productStr = diff > 1 ? "producten" : "product"

      switch (this.reason) {
        case "SOLD_TO_CUSTOMER": return `<b>${diff} ${productStr}</b> verkocht aan de klant.`
        case "ADDED_STOCK": return `<b>${diff} ${productStr}</b> toegevoegd aan de voorraad.`
        case "MODIFIED_IN_BACKOFFICE": {
          if (negative) return `<b>${diff} voorraad${productStr}</b> uit de backoffice verwijderd.`
          return `<b>${diff} ${productStr}</b> uit de backoffice toegevoegd.`
        }
        case "RETURNED_ORDER": return `Bestelling geretourneerd met <b>${diff} ${productStr}</b>.`
      }
    },
    formattedDate() {
      try {
        return this.createdAt && format(new Date(this.createdAt), "dd-MM-yyyy HH:mm")
      } catch (err) {
        return this.createdAt
      }
    },
  },
}

</script>

<style scoped>

.mutation {
  list-style: none;
}

.mutation + .mutation {
  border-top: 1px solid #E3E3E3;
}

.icon-wrapper {
  border-radius: 500px;
  color: white;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-wrapper.SOLD_TO_CUSTOMER {
  background-color: #10B981;
}

.icon-wrapper.ADDED_STOCK {
  background-color: #3B82F6;
}

.icon-wrapper.MODIFIED_IN_BACKOFFICE {
  background-color: #7A7A7A;
}

.icon-wrapper.RETURNED_ORDER {
  background-color: #EA580C;
}

.stock-info {
  margin-top: -7px;
}

.stock-info, .date {
  font-size: 11px;
  color: rgb(53, 59, 65, .85);
}

.date, .icon-wrapper {
  flex-shrink: 0;
}

.content {
  flex-grow: 1;
}

.text {
  font-size: 12px;
}

</style>
